import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-grid p-fluid" }
const _hoisted_2 = { class: "col-md-12" }
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_5 = {
  key: 0,
  class: "table align-middle table-row-dashed fs-6 fw-bold gy-4"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", { class: "text-start text-muted fw-bolder fs-7 gs-0" }, " Sipariş Toplam Adedi ", -1)
const _hoisted_7 = { class: "text-start text-muted fw-bolder fs-7 gs-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", { class: "text-start text-muted fw-bolder fs-7 gs-0" }, " Toplam Sevk Miktarı ", -1)
const _hoisted_9 = { class: "text-start text-muted fw-bolder fs-7 gs-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { class: "text-start text-muted fw-bolder fs-7 gs-0" }, " Sipariş Toplam Fiyat ", -1)
const _hoisted_11 = { class: "text-start text-muted fw-bolder fs-7 gs-0" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { class: "text-start text-muted fw-bolder fs-7 gs-0" }, " Toplam Sevk Tutarı ", -1)
const _hoisted_13 = { class: "text-start text-muted fw-bolder fs-7 gs-0" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", { class: "text-start text-muted fw-bolder fs-7 gs-0" }, " Sipariş Birim Fiyat ", -1)
const _hoisted_15 = { class: "text-start text-muted fw-bolder fs-7 gs-0" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", { class: "text-start text-muted fw-bolder fs-7 gs-0" }, " Fark Nedeni ", -1)
const _hoisted_17 = { class: "text-start text-muted fw-bolder fs-7 gs-0" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", { class: "text-start text-muted fw-bolder fs-7 gs-0" }, " Sevk Tarihi ", -1)
const _hoisted_19 = { class: "text-start text-muted fw-bolder fs-7 gs-0" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", { class: "text-start text-muted fw-bolder fs-7 gs-0" }, " Yükleme Tarihi ", -1)
const _hoisted_21 = { class: "text-start text-muted fw-bolder fs-7 gs-0" }
const _hoisted_22 = {
  class: "table align-middle table-row-dashed fs-6 fw-bold gy-4",
  id: "kt_subscription_products_table"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-muted fw-bolder fs-7 text-uppercase gs-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-40px" }, "Beden"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-40px" }, "Sipariş Adedi"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-40px" }, "Sevk Edilmiş"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-40px" }, "Sevk Edilen"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-40px" }, "Sevk Edilmeyen"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-40px" }, "Toplam Tutar")
  ])
], -1)
const _hoisted_24 = { class: "text-gray-600" }

import { ref, withDefaults, onMounted } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import DifferenceReason from "@/components/differenceReasons/DifferenceReason.vue";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { Field } from "vee-validate";
import Modal from "@/components/Modal.vue";
import { useToast } from "primevue/usetoast";
import moment from "moment";
import JwtService from "@/core/services/JwtService";
export interface PropsModel {
  id: number;
  isActive: boolean;
  shippingDetail: any;
  sizeRows: any;
  data: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'EditShipping',
  props: {
    id: { default: 0 },
    isActive: { type: Boolean, default: false },
    shippingDetail: { default: null },
    sizeRows: { default: null },
    data: { default: null }
  },
  emits: ["changeAddShipping", "changeAli"],
  setup(__props: any, { emit }) {

const props = __props as { id: number, isActive: boolean, shippingDetail: any, sizeRows: any, data: any }

const updateButtonDisabled = ref(false);


const toast = useToast();
const store = useStore();
const shippingDate = ref(moment(props.data?.deliveryDate).format("yyyy-MM-DD"));
let orderShippingDate = ref(
  moment(store.state.OrderModule.order.value.estimatedShippingDate).format(
    "yyyy-MM-DD"
  )
);
const isActive = ref(props.isActive);

// Eğer backendten differenceReason geliyorsa, globalDifferenceReason'a atayalım
const globalDifferenceReason: any = ref(null);
const globalReasonId = ref(null);

// Sayfa yüklendiğinde fark nedenini kontrol et
onMounted(() => {
  // Önce fark nedeni listesini yükleyelim
  store.dispatch(Actions.DIFFERENCE_REASON_LIST).then(() => {
    // Eğer props.data içinde differenceReason objesi varsa, doğrudan kullan
    if (
      props.data &&
      props.data.differenceReason &&
      props.data.differenceReason.id
    ) {
      globalReasonId.value = props.data.differenceReason.id;
      globalDifferenceReason.value = {
        name: props.data.differenceReason.name,
        value: props.data.differenceReason.id,
      };
    }
    // Eğer props.data içinde differenceReasonId varsa, bu değeri kullan
    else if (props.data && props.data.differenceReasonId) {
      globalReasonId.value = props.data.differenceReasonId;

      // Store'dan fark nedeni listesini kontrol et
      const reasonList =
        store.state.DifferenceReasonModule.differenceReason.value || [];
      const foundReason = reasonList.find(
        (r) => r.id === props.data.differenceReasonId
      );
      if (foundReason) {
        globalDifferenceReason.value = {
          name: foundReason.name,
          value: foundReason.id,
        };
      }
    }

    // Eğer deliveryLines içinde differenceReason varsa ve henüz bir değer atanmadıysa
    if (
      props.data &&
      props.data.deliveryLines &&
      props.data.deliveryLines.length > 0 &&
      !globalReasonId.value
    ) {
      const firstLine = props.data.deliveryLines[0];

      if (firstLine.differenceReason && firstLine.differenceReason.id) {
        globalReasonId.value = firstLine.differenceReason.id;
        globalDifferenceReason.value = {
          name: firstLine.differenceReason.name,
          value: firstLine.differenceReason.id,
        };
      } else if (firstLine.differenceReasonId) {
        globalReasonId.value = firstLine.differenceReasonId;

        // Store'dan fark nedeni listesini kontrol et
        const reasonList =
          store.state.DifferenceReasonModule.differenceReason.value || [];
        const foundReason = reasonList.find(
          (r) => r.id === firstLine.differenceReasonId
        );
        if (foundReason) {
          globalDifferenceReason.value = {
            name: foundReason.name,
            value: foundReason.id,
          };
        }
      }
    }
  });
});

const toggleModal = () => {
  isActive.value = !isActive.value;
};
// store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
// store.dispatch(Actions.DELIVERY_LINE_LIST, props.data.id).then((f) => {
//   store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
// });

const onChange = (args) => {
  emit("changeAddShipping", args);
};
const update = () => {
  store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
  var model = {
    deliveryId: props.data.id,
    shippingDate: !shippingDate.value.length
      ? moment(shippingDate.value).format("dd.mm.yyyy")
      : shippingDate.value,
    orderShippingDate:
      orderShippingDate.value == null
        ? null
        : !orderShippingDate.value.length
        ? moment(orderShippingDate.value).format()
        : orderShippingDate.value,
    orderLineId: props.shippingDetail.id,
    unitPrice: parseFloat(props.shippingDetail.price),
    differenceReasonId: globalReasonId.value,
    deliveryLines: props.shippingDetail.orderDetails.map((f) => {
      return {
        id: props.data.deliveryLines.find((g) => g.orderDetailId == f.id).id,
        orderDetailId: f.id,
        shippingQuantity: store.state.DeliveryModule.deliveryLine.value.find(
          (g) =>
            g.id ==
            props.data.deliveryLines.find((g) => g.orderDetailId == f.id).id
        ).shipped,
        differenceReasonId: globalReasonId.value,
      };
    }),
  };
  if (!model.shippingDate) {
    error("Sevk tarihi seçilmelidir!");
    return;
  }
  if (!model.orderShippingDate) {
    error("Yükleme tarihi seçilmelidir!");
    return;
  }
  store.dispatch(Actions.UPDATE_DELIVERY, model).then((f) => {
    if (f.success) {
      store
        .dispatch(Actions.ORDER_DETAIL, store.state.OrderModule.order.value.id)
        .then((f) => {
          store
            .dispatch(Actions.DELIVERY_LINE_LIST, props.data.id)
            .then((f) => {
              store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
            });
        });
      success(f.message);
      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
    } else {
      error(f.message);
      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
    }
  });
};
const reasonId = ref();
const reasons: any = ref([]);

const selectedDifferenceReason = (args) => {
  if (args && args.value) {
    globalReasonId.value = args.value;
    globalDifferenceReason.value = {
      name: args.name,
      value: args.value,
    };
  } else {
    globalReasonId.value = null;
    globalDifferenceReason.value = null;
  }
};
// const ali = (item) => {
//   var model = {
//     Id: reasonId.value,
//     orderDetailId: item.id,
//   };
//   if(model.Id){
//   reasons.value.push(model);
//   console.log(reasons.value);
//   }

// };
const success = (message) => {
  store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
  toast.add({
    severity: "success",
    summary: "İşlem Sonucu",
    detail: message,
    life: 3000,
  });
};
const error = (message) => {
  store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
  toast.add({
    severity: "error",
    summary: "İşlem Sonucu",
    detail: message,
    life: 3000,
  });
};
const onKeyup = (event) => {
  const next = event.target.getAttribute("sequence");
  let index = parseInt(next) + 1;
  if (event.keyCode == 13 || event.keyCode == 81 || event.keyCode == 32) {
    const nextElement = document.getElementsByName(
      "orderLinePrice-" + index
    )[0] as HTMLInputElement;
    if (nextElement) {
      nextElement.focus();
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock(Modal, {
    onClose: onChange,
    modalActive: props.isActive,
    title: "Sevkiyat Düzenle",
    width: "75vw",
    closable: false
  }, {
    footer: _withCtx(() => [
      (JSON.parse(_unref(JwtService).getUser()).roles.find((x) => x.id != 3))
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            label: "Güncelle",
            type: "button",
            icon: "pi pi-check",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (update())),
            autofocus: ""
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_unref(store).state.DeliveryModule.deliveryLine.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_unref(store).state.DeliveryModule.deliveryLine.value)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_5, [
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _hoisted_6,
                            _createElementVNode("td", _hoisted_7, _toDisplayString(props.shippingDetail.totalQuantity), 1),
                            _hoisted_8,
                            _createElementVNode("td", _hoisted_9, _toDisplayString(_unref(store).state.DeliveryModule.deliveryLine.value
                        .map((f) => parseInt(f.shipped))
                        .reduce(function (a, b) {
                          return a + b;
                        }, 0)), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_10,
                            _createElementVNode("td", _hoisted_11, _toDisplayString(parseFloat(props.shippingDetail.totalPrice)
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                        .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(props.shippingDetail.currency.symbol), 1),
                            _hoisted_12,
                            _createElementVNode("td", _hoisted_13, _toDisplayString(parseFloat(
                        _unref(store).state.DeliveryModule.deliveryLine.value[0]
                          ?.shippingPrice
                      )
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                        .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(props.shippingDetail.currency.symbol), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_14,
                            _createElementVNode("td", _hoisted_15, _toDisplayString(parseFloat(props.shippingDetail.price)
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                        .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(props.shippingDetail.currency.symbol), 1),
                            _hoisted_16,
                            _createElementVNode("td", _hoisted_17, [
                              _createVNode(DifferenceReason, {
                                onChangeDifferenceReason: selectedDifferenceReason,
                                data: globalDifferenceReason.value,
                                class: "difference-reason-dropdown"
                              }, null, 8, ["data"])
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_18,
                            _createElementVNode("td", _hoisted_19, [
                              _withDirectives(_createElementVNode("input", {
                                type: "date",
                                class: "p-inputtext p-component p-filled col-md-12 col-md-12",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((shippingDate).value = $event)),
                                required: ""
                              }, null, 512), [
                                [_vModelText, shippingDate.value]
                              ])
                            ]),
                            _hoisted_20,
                            _createElementVNode("td", _hoisted_21, [
                              _withDirectives(_createElementVNode("input", {
                                type: "date",
                                class: "p-inputtext p-component p-filled col-md-12 col-md-12",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(orderShippingDate) ? (orderShippingDate).value = $event : orderShippingDate = $event)),
                                required: ""
                              }, null, 512), [
                                [_vModelText, _unref(orderShippingDate)]
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("table", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("tbody", _hoisted_24, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.DeliveryModule
                    .deliveryLine.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          class: "odd",
                          key: index
                        }, [
                          _createElementVNode("td", null, _toDisplayString(item.size.name), 1),
                          _createElementVNode("td", null, _toDisplayString(item.quantity), 1),
                          _createElementVNode("td", null, _toDisplayString(item.totalShipped), 1),
                          _createElementVNode("td", null, [
                            (_openBlock(), _createBlock(_unref(Field), {
                              type: "text",
                              class: "form-control form-control-solid",
                              name: 'orderLinePrice-' + index,
                              onKeyup: onKeyup,
                              sequence: index,
                              key: index,
                              modelValue: item.shipped,
                              "onUpdate:modelValue": ($event: any) => ((item.shipped) = $event)
                            }, null, 8, ["name", "sequence", "modelValue", "onUpdate:modelValue"]))
                          ]),
                          _createElementVNode("td", null, _toDisplayString(item.quantity - item.totalShipped), 1),
                          _createElementVNode("td", null, _toDisplayString((parseFloat(props.shippingDetail.price) * item.shipped)
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                        .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(props.shippingDetail.currency.symbol), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})